export default function IconArrowDownload() {
  return (
    <svg
      id="icon_download2"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        id="Caminho_4327"
        data-name="Caminho 4327"
        d="M0,0H24V24H0Z"
        fill="none"
      />
      <path
        id="Caminho_4328"
        data-name="Caminho 4328"
        d="M3,19H21v2H3Zm10-5.828L19.071,7.1l1.414,1.414L12,17,3.515,8.515,4.929,7.1,11,13.17V2h2Z"
        fill="#959595"
      />
    </svg>
  );
}
